import { render, staticRenderFns } from "./EditBriefView.vue?vue&type=template&id=2d804a96&scoped=true"
import script from "./EditBriefView.vue?vue&type=script&lang=js"
export * from "./EditBriefView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d804a96",
  null
  
)

export default component.exports